/**
 * Shared mini SlidePreview used for template thumbnails + sidebar thumbs.
 * Same visual rules as the editor preview but read-only.
 */
export function MiniSlidePreview({ slide, theme, brandLogo }) {
  const c = theme || {};
  const isDark = c.bg && (c.bg.toLowerCase() === "#0b0d17" || c.bg === "#0f172a");
  const imgSrc = slide?.image_data ? `data:image/png;base64,${slide.image_data}` : null;
  if (!slide) return null;
  return (
    <div className="relative w-full h-full overflow-hidden rounded" style={{ aspectRatio: "16/9", background: c.bg || "#FFFFFF", color: c.fg || "#0B0D17" }}>
      <div className="absolute left-0 top-0 bottom-0" style={{ width: 3, background: c.primary || "#0B5CFF" }} />
      {brandLogo && <img src={brandLogo} alt="" className="absolute top-1 right-1 h-3 object-contain z-10" />}
      <div className="absolute inset-0 p-2 flex flex-col">
        <div>
          <div className="font-display font-black leading-tight truncate" style={{ color: c.primary || "#0B5CFF", fontSize: "9px" }}>
            {slide.title}
          </div>
          {slide.subtitle && (
            <div className="opacity-70 truncate" style={{ color: c.secondary || c.fg || "#4A4D57", fontSize: "6px" }}>{slide.subtitle}</div>
          )}
        </div>
        <div className="flex-1 mt-1 grid grid-cols-2 gap-1">
          <div className="space-y-0.5">
            {(slide.content || []).slice(0, 3).map((item, i) => (
              <div key={i} className="flex items-start gap-1">
                <div className="w-1 h-1 rounded-full mt-1 shrink-0" style={{ background: c.accent || "#F59E0B" }} />
                <div className="text-[6px] leading-tight truncate">{item}</div>
              </div>
            ))}
          </div>
          {imgSrc ? (
            <div className="rounded overflow-hidden">
              <img src={imgSrc} alt="" className="w-full h-full object-cover" />
            </div>
          ) : (slide.chart ? (
            <div className="rounded p-1" style={{ background: isDark ? "rgba(255,255,255,.06)" : "rgba(0,0,0,.04)" }}>
              {(slide.chart.labels || []).slice(0, 2).map((l, i) => {
                const max = Math.max(...(slide.chart.values || [1]));
                const v = (slide.chart.values || [])[i] || 0;
                return (
                  <div key={i} className="mb-0.5">
                    <div className="h-0.5 rounded" style={{ background: isDark ? "rgba(255,255,255,.1)" : "rgba(0,0,0,.08)" }}>
                      <div className="h-full rounded" style={{ width: `${(v/max)*100}%`, background: c.primary || "#0B5CFF" }} />
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null)}
        </div>
      </div>
    </div>
  );
}
